import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';
import { IconButton, toast } from '@orgus/ui';

/** A block of text to paste somewhere else, with a copy button. */
export function CopyBlock({ text, label, multiline }: { text: string; label: string; multiline?: boolean }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1800);
    return () => clearTimeout(t);
  }, [copied]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch (e) {
      toast.error(e);
    }
  };
  return (
    <div className="flex items-start gap-2 rounded-md border border-border bg-bg py-2 pl-3 pr-1.5">
      {multiline ? (
        <pre className="min-w-0 flex-1 select-all whitespace-pre-wrap break-all py-0.5 font-mono text-sm leading-relaxed text-fg" aria-label={label}>
          {text}
        </pre>
      ) : (
        <code className="min-w-0 flex-1 select-all break-all py-0.5 font-mono text-sm leading-relaxed text-fg" aria-label={label}>
          {text}
        </code>
      )}
      <IconButton label={copied ? 'Copied' : `Copy ${label.toLowerCase()}`} icon={copied ? <Check className="text-passed" /> : <Copy />} size="sm" onClick={copy} />
    </div>
  );
}
